import {apiFetch, downloadApiBlob} from '../api/fetch'
import {
    type EquipmentExceptions,
    equipmentExceptionsSchema,
    type WaitingForUnitNumber,
    waitingForUnitNumbersSchema,
} from './schemas'

function buildYardQueryString(yardId: string | null): string {
    return yardId ? `?${new URLSearchParams({dispatch_yard_id: yardId})}` : ''
}

export async function listEquipmentExceptions(yardId: string | null): Promise<EquipmentExceptions> {
    const raw = await apiFetch<unknown>(`/equipment/exceptions${buildYardQueryString(yardId)}`)
    return equipmentExceptionsSchema.parse(raw)
}

export async function listWaitingForUnitNumbers(
    yardId: string | null,
): Promise<WaitingForUnitNumber[]> {
    const raw = await apiFetch<unknown>(
        `/equipment/waiting-for-unit-numbers${buildYardQueryString(yardId)}`,
    )
    return waitingForUnitNumbersSchema.parse(raw)
}

export async function downloadInventoryCsv(yardId: string | null): Promise<void> {
    await downloadApiBlob(
        `/equipment/inventory.csv${buildYardQueryString(yardId)}`,
        'inventory.csv',
    )
}
